import { EEntityType } from '@sharedInterfaces/globalEnums';
import type IEmployeeTalk from '@sharedInterfaces/IEmployeeTalk';
import type { EEmployeeTalkStatus } from '@sharedInterfaces/IEmployeeTalk';
import type { IEmployeeTalkState } from '@sharedInterfaces/IEmployeeTalkState';
import type IEmployeeTalkTemplate from '@sharedInterfaces/IEmployeeTalkTemplate';

import { Entity, entityFieldsGQL } from './Entity';

export const EmployeeTalkGQL = `{
  id
  title
  employeeId
  meetingPartnerId
  templateId
  templateVersion
  templateData
  createdById
  scheduledDate
  actualDate
  durationMinutes
  loc
  talkState
  suggestionsId
  status2
  followUpDate
  employeeConfirmed
  partnerConfirmed
  ${entityFieldsGQL}
}`;

export default class EmployeeTalk extends Entity implements IEmployeeTalk {
    declare id: number;
    readonly type = EEntityType.EMPLOYEE_TALK;
    employeeId: number;
    meetingPartnerId: number;
    templateId: number;
    templateVersion: string;
    templateData: IEmployeeTalkTemplate;
    createdById: number;
    scheduledDate: string | undefined;
    actualDate?: string;
    durationMinutes?: number;
    loc?: string;
    talkState: IEmployeeTalkState;
    suggestionsId?: string;
    status2: EEmployeeTalkStatus;
    followUpDate?: string;
    employeeConfirmed: boolean;
    partnerConfirmed: boolean;

    constructor(obj: IEmployeeTalk) {
        super(obj);
        this.employeeId = obj.employeeId;
        this.meetingPartnerId = obj.meetingPartnerId;
        this.templateId = obj.templateId;
        this.templateVersion = obj.templateVersion;
        this.templateData = obj.templateData;
        this.createdById = obj.createdById;
        this.scheduledDate = obj.scheduledDate;
        this.actualDate = obj.actualDate;
        this.durationMinutes = obj.durationMinutes;
        this.loc = obj.loc;
        this.talkState = obj.talkState;
        this.suggestionsId = obj.suggestionsId;
        this.status2 = obj.status2;
        this.followUpDate = obj.followUpDate;
        this.employeeConfirmed = obj.employeeConfirmed;
        this.partnerConfirmed = obj.partnerConfirmed;
    }

    async delete() {
        const { default: deleteEmployeeTalk } = await import('@src/APIs/graphQl/EmployeeTalk/deleteEmployeeTalk');
        return deleteEmployeeTalk(this.id);
    }
}
